import { Card, CardContent, Chip, Typography, Box, Button, CircularProgress } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ReportItem } from "../../api-request/api-request";
import ReusableSelect from "./ReportSelect";

interface ReportCardProps {
  report: ReportItem;
  onDownload: (item: ReportItem) => void
  downloading?: boolean;
  parameterValues?: Record<string, string>;
  onParameterChange?: (
    reportCode: string,
    parameterCode: string,
    value: string
  ) => void;
}

// Reportcard
export default function ReportCard({
  report,
  onDownload,
  downloading,
  parameterValues = {},
  onParameterChange,
}: ReportCardProps) {
  return (
    <Card className="h-full rounded-2xl border border-gray-200 shadow-sm">
      <CardContent className="flex flex-col gap-3 p-4 sm:p-5">
        <Box className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <Box className="flex min-w-0 items-start gap-2">
            <DescriptionOutlinedIcon color="action" className="mt-0.5 shrink-0" />

            <Typography
              variant="h6"
              className="break-words text-base font-semibold sm:text-lg"
            >
              {report.title}
            </Typography>
          </Box>

          <Chip
            label={report.type}
            size="small"
            color="primary"
            variant="outlined"
            className="self-start"
          />
        </Box>

        <Typography
          variant="body2"
          className="break-words text-sm leading-6 text-gray-600"
        >
          {report.description || "No description available."}
        </Typography>

        {report.parameters?.length > 0 && (
          <div className="flex flex-col gap-3">
            {report.parameters.map((param) => (
              <ReusableSelect
                key={param.code}
                label={param.label}
                value={parameterValues[param.code] || ""}
                options={param.options}
                onChange={(value: any) =>
                  onParameterChange?.(report.code, param.code, value)
                }
              />
            ))}
          </div>
        )}

        <Button
          onClick={() => onDownload(report)}
          startIcon={
            downloading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <DescriptionOutlinedIcon />
            )
          }
          variant="outlined"
          size="small"
          className="w-full sm:w-fit"
          sx={{ textTransform: "none" }}
        >
          {downloading ? "Downloading..." : "Download Report"}
        </Button>
      </CardContent>
    </Card>
  );
}